import { FETCH_WITH_TOKEN } from '@services/react-query/config'
import { GET_USER_SAVED_ITEMS } from '@services/react-query/urls/courses'
import { useQuery } from '@tanstack/react-query'
import { ShortCourse } from '@ugu/types'

const useGetSavedItems = (enabled = false) => {
  const { ...data } = useQuery<ShortCourse[]>({
    queryKey: ['saved-items'],
    queryFn: () => FETCH_WITH_TOKEN(GET_USER_SAVED_ITEMS()),
    enabled: enabled,
  })
  return data
}

export default useGetSavedItems
